import { useTranslation } from 'react-i18next';
import { Avatar } from 'antd';
import { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuthContext } from '@/hooks/auth';
import { getInvitationInfo, getCurrentPlanNew, getMonthlySummary } from '@/api/subtitles';
import SvgIcon from '@/components/SvgIcon';
import styles from './menu.module.less';
import { FileTextOutlined, FileWordOutlined, ClockCircleOutlined } from '@ant-design/icons';
import { trackEvent, TrackingEvent, MenuItem } from '@/utils/tracking';

function MenuContent() {
  const { t } = useTranslation();
  const { state } = useAuthContext();
  const { isLogin, user } = state;
  const [sendTime, setSendTime] = useState<number>(0);
  // 预付用户=剩余时长，按量用户=已用时长；null 表示数据未就绪
  const [planSeconds, setPlanSeconds] = useState<number | null>(null);
  // 预付用户（total_limit === 'LIMITED'）展示充值按钮与剩余时长
  const [isPrepaid, setIsPrepaid] = useState(true);
  const navigate = useNavigate();
  // const navigation = useNavigation();
  let location = useLocation();
  const getSendTime = async () => {
    const res = await getInvitationInfo();
    setSendTime(res.data.data.durations / 60);
  };

  const getCurrentTime = async () => {
    const res = await getCurrentPlanNew();
    const primary = res.data.data?.user_product_total?.[0];

    if (primary) {
      const prepaid = primary.total_limit === 'LIMITED';
      setIsPrepaid(prepaid);
      if (prepaid) {
        // 预付用户展示剩余时长
        setPlanSeconds(primary.balance);
      } else {
        // 按量用户展示本月已用时长
        const summary = await getMonthlySummary();
        setPlanSeconds(summary.data.data?.total_duration ?? 0);
      }
    }
  };

  // 将秒格式化为「X 小时 Y 分」或「Y 分钟」
  const formatDuration = (seconds: number) => {
    const totalMinutes = Math.floor(seconds / 60);
    const h = Math.floor(totalMinutes / 60);
    const m = totalMinutes % 60;
    return h > 0 ? t('planHourMin', { h, m }) : t('planMin', { m });
  };

  useEffect(() => {
    getSendTime();
  }, []);

  useEffect(() => {
    if (isLogin) {
      getCurrentTime();
    }
  }, [isLogin]);

  const onClickToHome = () => {
    window.open(import.meta.env.VITE_FELO_HOME_URL);
  };

  const onclickToFeedback = () => {
    window.open(`${window.location.origin}/feedback`);
  };

  const clickMenu = (item: string) => {
    // 侧边栏点击埋点
    let menuItem: MenuItem | undefined;
    switch (item) {
      case 'record':
        menuItem = MenuItem.HISTORY;
        break;
      case 'keyword':
        menuItem = MenuItem.RECOG_DICT;
        break;
      case 'termbase':
        menuItem = MenuItem.TRANS_DICT;
        break;
      default:
        // 其他菜单项不需要埋点
        break;
    }

    if (menuItem) {
      trackEvent(TrackingEvent.SIDEBAR_CLICK, { menu_item: menuItem });
    }

    navigate(`/${item}`);
  };

  const openPricingpage = (e: any) => {
    e.stopPropagation(); // 阻止事件冒泡
    window.open(`${import.meta.env.VITE_FELO_SUBTITLES_URL}/pricing`);
  };
  const toInviteClick = () => {
    window.open(`${import.meta.env.VITE_FELO_SUBTITLES_URL}/invite`);
  };
  const checkLink = (text: string) => {
    return location.pathname.includes(text);
  };

  return (
    <div className={styles.newmenucontent}>
      <div className={styles.downloadInfo} onClick={onClickToHome}>
        <SvgIcon className={styles.icon} name="download-two" />
        <div className={styles.downloadInfoText}>{t('useClient')}</div>
      </div>
      <div className={styles.menuitems}>
        <div
          onClick={() => clickMenu('record')}
          className={`${styles.menuItem} ${checkLink('record') ? styles.selectItem : ''}`}
        >
          <SvgIcon className={styles.icon} name="recordLog" />
          <div className={styles.menuText}>{t('translationRecord')}</div>
        </div>
        <div
          onClick={() => clickMenu('keyword')}
          className={`${styles.menuItem} ${checkLink('keyword') ? styles.selectItem : ''}`}
        >
          <FileTextOutlined className={styles.icon} />
          <div className={styles.menuText}>{t('keyWordList')}</div>
        </div>
        <div
          onClick={() => clickMenu('termbase')}
          className={`${styles.menuItem} ${checkLink('termbase') ? styles.selectItem : ''}`}
        >
          <FileWordOutlined className={styles.icon} />
          <div className={styles.menuText}>{t('termbase.name')}</div>
        </div>
        {/* <div onClick={() => clickMenu('share-link')} className={`${styles.menuItem} ${checkLink('share-link') ? styles.selectItem : ''}`}>
          <FileTextOutlined className={styles.icon} />
          <div className={styles.menuText}>{t('shareLink')}</div>
        </div> */}
      </div>
      <div className={styles.invitecontent}>
        <div className={styles.invitetext}>{t('invitefriend')}</div>
        <div
          className={styles.inviteTimetext}
          dangerouslySetInnerHTML={{ __html: t('earntime', { time: sendTime }) }}
        ></div>
        <div className={styles.inviteButton} onClick={toInviteClick}>
          {t('inviteNow')}{' '}
        </div>
      </div>
      <div className={`${styles.boderdiv} ${styles.footerDivider}`}></div>
      <div className={styles.fottermenu}>
        <div
          className={`${styles.menuItem} ${checkLink('review-rewards') ? styles.selectItem : ''}`}
          onClick={() => clickMenu('review-rewards')}
        >
          <SvgIcon className={styles.icon} name="star-reward" />
          <div className={styles.menuText}>{t('reviewRewards.title')}</div>
        </div>
        <div className={styles.menuItem} onClick={onclickToFeedback}>
          <SvgIcon className={styles.icon} name="file-pen" />
          <div className={styles.menuText}>{t('feedback')}</div>
        </div>
        {/* <div className={styles.menuItem}  onClick={()=>clickMenu('Setting')}>
            <SvgIcon className={styles.icon} name="record" />
            <div>{t('setting')}</div></div> */}
        <div className={styles.menuItem} onClick={onClickToHome}>
          <SvgIcon className={styles.icon} name="grip" />
          <div className={styles.menuText}>{t('moreProducts')}</div>
        </div>
      </div>
      <div className={styles.boderdiv}></div>
      <div
        onClick={() => clickMenu('account')}
        className={`${styles.usercontent} ${checkLink('account') ? styles.selectItem : ''}`}
      >
        <div className={styles.userTopRow}>
          <Avatar
            className={styles.felosubtitleavatar}
            style={{ backgroundColor: user?.picture?.indexOf('http') >= 0 ? 'transparent' : 'rgb(36, 141, 247)' }}
            size={36}
            src={user?.picture?.indexOf('http') >= 0 ? user.picture : null}
          >
            {user?.email?.charAt(0).toLocaleUpperCase()}
          </Avatar>
          <div className={styles.useName} title={user?.email}>
            {user?.email}
          </div>
          {planSeconds !== null && isPrepaid && (
            <div className={styles.topUpbotton} onClick={(e) => openPricingpage(e)}>
              {t('topUp')}
            </div>
          )}
        </div>
        <div className={styles.userDivider}></div>
        <div className={styles.userPlanRow}>
          {planSeconds === null ? (
            <>
              <div className={`${styles.planSkeleton} ${styles.planSkeletonText}`}></div>
              <div className={`${styles.planSkeleton} ${styles.planSkeletonBadge}`}></div>
            </>
          ) : (
            <>
              <div className={styles.planDuration}>
                <ClockCircleOutlined
                  className={`${styles.planIcon} ${isPrepaid ? styles.planIconPrepaid : styles.planIconMetered}`}
                />
                <span className={styles.planDurationText}>
                  {isPrepaid
                    ? t('planRemaining', { time: formatDuration(planSeconds) })
                    : t('planUsed', { time: formatDuration(planSeconds) })}
                </span>
              </div>
              <span className={`${styles.planBadge} ${isPrepaid ? styles.planBadgePrepaid : styles.planBadgeMetered}`}>
                {isPrepaid ? t('planPrepaid') : t('planMetered')}
              </span>
            </>
          )}
        </div>
      </div>
    </div>
  );
}

export default MenuContent;
